import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { FormFeedback } from 'reactstrap';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { getEndDate } from '../../utils/getEndDate';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.css';

const DatePickerInput = (props) => {
  //  const [date, setDate] = useState("");
  const [datesArr, setDatesArr] = useState([]);
  if (props && props.nextItemName) {
    console.log(props, '!11111111!!!!!!!! date props');
  }
  useEffect(() => {
    setDatesArr(props.month_dates.dates);
  }, [props.month_dates.dates]);

  const handleChange = (date) => {
    // setDate(date);

    props.input.onChange(new Date(date + '  GMT'));
    const formInputName = props.input.name;

    const toInputName = formInputName.replace('date_from', 'date_to');
    if (props.dateType === 'month') {
      const endDate = getEndDate(date);
      props.dispatch(change('DealForm', toInputName, endDate));

      //update any future optoins
      if (props && props.optionsLength > 1) {
        for (let index = 1; index <= props.optionsLength; index++) {
          const newNumber = parseInt(props.dateIndex) + index;

          props.dispatch(
            change(
              'DealForm',
              props.nextItemName + '[' + newNumber + '].date_from',
              endDate
            )
          );
          props.dispatch(
            change(
              'DealForm',
              props.nextItemName + '[' + newNumber + '].date_to',
              endDate
            )
          );
        }
      }
    }
  };

  const selected = props.input.value
    ? new Date(new Date(props.input.value).toDateString())
    : null;

  // var monthEndDay =
  //   datesArr.length &&
  //   props.fieldName === "date_to" &&
  //   new Date(
  //     new Date(datesArr[props.dateIndex]["date_from"] + " GMT").getFullYear(),
  //     new Date(datesArr[props.dateIndex]["date_from"] + " GMT").getMonth() + 1,
  //     0
  //   );

  // const minDate =
  //   props.fieldName === "date_to" &&
  //   datesArr.length &&
  //   new Date(datesArr[props.dateIndex]["date_from"]);

  // const maxDate = props.fieldName === "date_to" && monthEndDay;

  return (
    <div>
      <DatePicker
        selected={selected}
        dateFormat={props.dateFormat}
        showYearDropdown
        className={
          props.meta.touched && props.meta.error
            ? 'is-invalid form-control'
            : 'form-control'
        }
        placeholderText={props.placeholder}
        onChange={handleChange}
        showMonthYearPicker={props.dateType === 'month' ? true : false}
        // minDate={minDate}
        // maxDate={maxDate}
        showDisabledMonthNavigation
        {...props}
      />
      {props.meta.touched && props.meta.error && (
        <FormFeedback style={{ display: 'block' }}>
          {props.meta.error}
        </FormFeedback>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  month_dates:
    state.form.DealForm.values.month_dates &&
    state.form.DealForm.values.month_dates[0],
});

export default connect(mapStateToProps)(DatePickerInput);



// WEBPACK FOOTER //
// ./src/system/fields/DatePicker/index.jsx